import { createAction, handleActions } from 'redux-actions'
import update from 'immutability-helper'

const UPDATE_STATE = 'CROWD_MANAGEMENT_UPDATE_STATE'

const initialState = {
  customerList: [] as any[],
  userCrowdInfo: {currentCrowdCount: 0, totalCrowdCount: 0, expiringCrowdCount: 0 } as any,
  /// 比较人群选择缓存列表
  compareList: [] as any,
  currentEditTagIndex: -1
}

export type CrowdManageState = typeof initialState

function setState<T> (state: CrowdManageState, field: string, value: T): CrowdManageState {
  if (!state.hasOwnProperty(field)) {
    console.error(`modules-crowd-management-reducer[ERROR]: can't find ${field} property in CrowdManageState`)
  }
  return update(state, { [field]: { $set: value } })
}

export default handleActions<CrowdManageState>({
  [UPDATE_STATE] (state,  { payload }) {
      let s = state
      for (let key in payload) 
        s = setState(s, key, payload[key])
      
      return s
  },
  
}, initialState)

export const updateStateAction = createAction(UPDATE_STATE)
export const updateState = params => dispatch => {
  dispatch(updateStateAction(params))
}
